import type { FilterResult } from '@components/Home/HomePageSearchModal'
import { contentLibrary } from '@components/shared/contentLibrary'
import homeDefaultSearchResult, {
  defaultSearchResultWithoutKuran,
} from 'data/homeDefaultSearchResult'
import surahs from 'data/surahs'
import { getSurahPageHref } from './surahAnchor'
import { checkIfWordExists, getDynamicSearchResults, getQuranSurahAyah } from './kuran'

// Match the legacy /api/home ordering, keeping curated defaults ahead of the catalog.
const otherSearchResults: FilterResult[] = [
  ...defaultSearchResultWithoutKuran,
  ...contentLibrary
    .filter((item) =>
      defaultSearchResultWithoutKuran.every(
        (defaultItem) => defaultItem.name !== item.name,
      ),
    )
    .map((item) => ({
      name: item.name,
      keywords: item.keywords,
      url: `/${item.url}`,
    })),
]

/** Searches lightweight local metadata in the established global result order. */
export function getHomeSearchResults(word: string): FilterResult[] {
  const matchingSurahs = surahs
    .filter((surah) => checkIfWordExists(word, surah))
    .map((surah) => ({
      name: `${surah.name} Suresi`,
      url: getSurahPageHref(surah),
      keywords: surah.name,
    }))
  const matchingOthers = otherSearchResults.filter((item) =>
    checkIfWordExists(word, item),
  )
  const results = [
    ...getQuranSurahAyah(word, surahs),
    ...matchingSurahs,
    ...matchingOthers,
    ...getDynamicSearchResults(word),
  ]

  return !results.length && !word ? homeDefaultSearchResult : results
}
